<div
  class="card campanha-pipeline-card-info campanha-pipeline-card-info-nao-confirmada"
>
  <div class="card-header">
    <h6 class="card-title">Criação</h6>
  </div>
  <div class="card-body">
    <ul class="list-group list-group-flush">
      <li class="list-group-item">
        <span class="list-group-item-values">
          <span class="list-group-item-value">
            <i class="far fa-calendar"></i>
            {{ createdAt | date : "dd/MM/yyyy" }}
          </span>
          <span class="list-group-item-value">
            <sgt-avatar
              [settings]="{
                imageUrl: avatarURLUsuarioCreated,
                fullName: nomeUsuarioCreated,
                isShowLabelNameLeft: true,
                minInitialsLength: 1
              }"
            >
            </sgt-avatar>
          </span>
        </span>
      </li>
    </ul>
  </div>
</div>
